import Cookies from 'js-cookie';
import Vue from 'vue';
import Vuelidate from 'vuelidate';
import VueMask from 'v-mask';
import 'select2'; // globally assign select2 fn to $ element
import 'select2/dist/css/select2.css';
import 'daterangepicker/daterangepicker.css';
import 'sweetalert2/dist/sweetalert2.min.css';
import VueSweetalert2 from 'vue-sweetalert2';

require('./bootstrap');
require('daterangepicker');

Vue.use(Vuelidate);

Vue.use(VueSweetalert2);
Vue.use(VueMask, {
  placeholders: {
    D: /[1,2]/, // define new placeholder
    F: /[0,9]/, // define new placeholder
    E: /[0,1,6,7,8,9]/,
    G: /[0,1]/,
    H: /[0,1,2,3]/,
  },
});

let cookieStatement = Cookies.get('statement');
if (cookieStatement === undefined || !cookieStatement) {
  $('footer').addClass('fixed');
} else {
  $('footer').removeClass('fixed');
}
// console.log(cookie_statement);

// 設定cookie
$('footer .statement a.know').on('click', () => {
  cookieStatement = Cookies.set('statement', 'open', {
    expires: 3000,

  });
  $('footer').removeClass('fixed');
  // console.log(cookie_statement);
});
